export const orderPaths = {
	ORDER: "/",
};
